import { ArcDto } from './model.dto'
import PaginatedResponse from '../base/paginatedResponse'
import { ObjectType } from '@nestjs/graphql'

@ObjectType()
export class ArcPagedResultDto extends PaginatedResponse(ArcDto) {}
